import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from 'automation-ui-canvas/reducers';
// @ts-expect-error untyped module
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
const createStoreWithMiddleware = compose(applyMiddleware(thunk, NotificationMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : enhancedCreateStore => enhancedCreateStore)(createStore);
export default function configureStore(initialState = {}) {
  return createStoreWithMiddleware(rootReducer, initialState);
}